(function (algolia, instantsearch) {

  var liquid = document.getElementById("liquid-json").innerHTML,
      liquid = JSON.parse(liquid || '{}');

  var collectionFacetConstraint = !!algolia.is_collection_results_page &&
    !!algolia.config.instant_search_enabled_on_collection;

  if ( !algolia.full_results && !collectionFacetConstraint ) {
    return;
  }

  if ( !algolia.config.instant_search_enabled ) {
    return;
  }

  var _ = algolia._,
      $ = algolia.jQuery;

  var collectionFacetValue = null;
  if (collectionFacetConstraint) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    if (!!matches && matches.length === 2) {
      collectionFacetValue = matches[1];
    }
  }

  algolia.config.results_selector += ', .algolia-shopify-instantsearch';

  var $hiding = $('<style>' + algolia.config.results_selector + ' { visibility: hidden }</style>');
  $hiding.appendTo($('head'));

  // Product index
  var instant = algolia.instantsearch = {
    colors: algolia.config.colors,
    distinct: !!algolia.config.show_products,
    facets: {
      hidden: algolia.hiddenFacets,
      shown: algolia.shownFacets,
      list: algolia.facets,
      widgets: algolia.facetsWidgets
    },
    hitsPerPage: algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
      indexName: '' + algolia.config.index_prefix + 'products',
      searchParameters: {
       clickAnalytics: true
      },
      urlSync: {},
      searchFunction: function (searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var helper = instant.search.helper;
        var page = helper.getPage();
        helper.setQueryParameter('highlightPreTag', '<span class="ais-highlight">');
        helper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          helper.setQueryParameter('distinct', true);
        }
        if (!!collectionFacetConstraint && !!collectionFacetValue) {
          helper.setQueryParameter('filters', 'collections:"' + collectionFacetValue + '"');
        }
        helper.setPage(page);
        searchFunctionHelper.search();
      }
    }),
    selector: algolia.config.results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: algolia.sortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate('instant_search_current_refined_values_item'),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      style: algolia.compileTemplate('instant_search.css')
    }
  };

  function readjust() {
    var width = instant.$results.outerWidth();

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results
      .removeClass('ais-results-size-xs')
      .removeClass('ais-results-size-sm')
      .removeClass('ais-results-size-md')
      .removeClass('ais-results-size-lg')
      .addClass('ais-results-size-' + suffix);
  }

  _.forEach(Object.assign({}, algolia.helpers, algolia.translation_helpers), function (helper, name) {
    instant.search.templatesConfig.helpers[name] = helper;
  });

  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(algolia.render(instant.templates.style, {
    distinct: instant.distinct,
    colors: instant.colors
  }));

  // Page index
  var instantPages = {
    search: instantsearch({
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
      indexName: '' + algolia.config.index_prefix + "pages",
      searchParameters: {
        clickAnalytics: true
      },
      urlSync: {},
    }),
    templates: {
      empty: instant.templates.empty,
      pageItem: algolia.getTemplate('instant_search_page')
    }
  };

  instantPages.search.templatesConfig.compileOptions = algolia.hoganOptions;

  // Zen index
  var instantZen = {
    search: instantsearch({
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
      indexName: '' + algolia.config.index_prefix + "zendesk_",
      searchParameters: {
        clickAnalytics: true
      },
      urlSync: {},
    }),
    templates: {
      empty: instant.templates.empty,
      pageItem: algolia.getTemplate('instant_search_page')
    }
  };

  instantZen.search.templatesConfig.compileOptions = algolia.hoganOptions;

  // Pages - handle page only searches
  $(document).on("algolia:productsempty", function () {
    $(".ais-page-hits-container").show();
    $(".ais-page-stats-container").show();
    $(".ais-zen-hits-container").show();
    $(".ais-zen-stats-container").show();
  });

  instant.search.on("render", function () {
    var container = $(".ais-page");
    var productHitsEmpty = $(".ais-infinite-hits__empty");
    var sortBySelector = $(".ais-sort");

    if ( productHitsEmpty.length ) {
      container.addClass("ais-page__empty");
      productHitsEmpty.hide();
      $(document).trigger("algolia:productsempty");
    } else {
      sortBySelector.removeClass("ais-sort__hidden");
    }
  });

  $(document).ready(function () {

    // Render instant search page layout - widgets are rendered individually
    instant.$results = $(instant.selector);

    instant.$results.html(algolia.render(instant.templates.page, {
      facets: instant.facets.list,
      storeName: instant.storeName,
      translations: algolia.translations
    }));

    readjust();

    $(window).resize(function () {
      readjust();
    });

    // Mobile facets display
    instant.search.addWidget({
      init: function (opts) {
        var $button = $('.ais-facets-button');
        $button.on('click', function () {
          var $facets = $('.ais-facets');

          if ($facets.hasClass('ais-facets__shown')) {
            $button.text(algolia.translations.showFilters);
            $facets.removeClass('ais-facets__shown');
          } else {
            $button.text(algolia.translations.hideFilters);
            $facets.addClass('ais-facets__shown');
          }
        });
      }
    });

    // Search input
    instant.search.addWidget(
      instantsearch.widgets.searchBox({
        container: '.ais-search-box-container',
        placeholder: algolia.translations.searchForProduct,
        poweredBy: false
      })
    );

    // Logo & clear
    instant.search.addWidget({
      init: function (opts) {
        if (!instant.poweredBy) {
          $('.ais-algolia-icon').hide();
        }
        $('.ais-clear-input-icon').on('click', function () {
          opts.helper.setQuery('').search();
          $('.ais-search-box--input').val('').focus();
        });
      },
      render: function (opts) {
        if (!opts.state.query) {
          if (instant.poweredBy) {
            $('.ais-algolia-icon').show();
          }
          $('.ais-clear-input-icon').hide();
        } else {
          $('.ais-clear-input-icon').show();
          $('.ais-algolia-icon').hide();
        }
      }
    });

    // Stats
    instant.search.addWidget(
      instantsearch.widgets.stats({
        container: '.ais-stats-container',
        templates: {
          body: instant.templates.stats
        },
        transformData: {
          body: function (data) {
            data.processingTimeS = data.processingTimeMS / 1000;
            data.start = data.page * data.hitsPerPage + 1;
            data.end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits);
            data.translations = algolia.translations;
            return data;
          }
        }
      })
    );

    // Sort orders
    instant.search.addWidget(
      instantsearch.widgets.sortBySelector({
        container: '.ais-sort-orders-container',
        indices: instant.sortOrders
      })
    );

    // Hidden facets
    var list = _.map(instant.facets.hidden, function (facet) { return facet.name; });
    instant.search.addWidget({
      getConfiguration: function () {
        return {
          facets: list,
          disjunctiveFacets: list
        };
      },
      init: function () {}
    });

    // Current refined values
    var attributes = _.map(instant.facets.shown, function (facet) {
      return {
        name: facet.name,
        label: facet.title
      }
    });
    instant.search.addWidget(
      instantsearch.widgets.currentRefinedValues({
        container: '.ais-current-refined-values-container',
        cssClasses: {
          root: 'ais-facet',
          header: 'ais-facet--header',
          body: 'ais-facet--body'
        },
        templates: {
          header: algolia.translations.selectedFilter,
          item: instant.templates.currentItem,
          clearAll: algolia.translations.clearAll
        },
        onlyListedAttributes: true,
        attributes: attributes
      })
    );

    // Facets
    _.forEach(instant.facets.widgets, function (widget) {
      instant.search.addWidget(instantsearch.widgets[widget.name](widget.params));
    });

    // Hits
    instant.search.addWidget(
      instantsearch.widgets.infiniteHits({
        container: '.ais-hits-container',
        hitsPerPage: instant.hitsPerPage,
        templates: {
          empty: instant.templates.empty,
          item: instant.templates.product
        },
        showMoreLabel: algolia.translations.showMoreResults,
        transformData: {
          item: function (product) {
            product._distinct = instant.distinct;
            product.can_order = (
              product.inventory_management !== 'shopify' ||
              product.inventory_policy === 'continue' ||
              product.inventory_quantity > 0
            );
            product.sold_out = !product.can_order;
            product.translations = algolia.translations;
            product.queryID = instant.search.helper.lastResults._rawResults[0].queryID;
            product.productPosition = product.__hitIndex + 1;

            product.preorder = false;

            product.tags.forEach(function (tag) {
              let tagLower = tag.toLowerCase();
              if ( tagLower.indexOf("preorder_") !== -1 ) {
                product.preorder = true;
              }
            });

            if ( product.inventory_quantity === 0) {
              product.sold_out = true;
            }

            if ( product.preorder && product.sold_out ) {
              product.preorder = false;
            }

            if ( product.preorder ) {
              product.can_order = false;
            }

            product.not_sold_directly = false;

            if ( liquid.shop.permanent_domain == "os-trau.myshopify.com" || liquid.shop.permanent_domain == "tb-latam.myshopify.com" ) {
              product.not_sold_directly = true;
              product.preorder = false;
              product.can_order = false;
              product.sold_out = false;
            }

            if ( liquid.shop.permanent_domain == "os-trnz.myshopify.com" ) {
              product._distinct = true; // no add to cart
            }

            product.bundle = false;

            if ( product.product_type == "Bundle" ) {
              product.bundle = true;
              product.can_order = false;
              product.sold_out = false;
            }

            return product;
          },
          empty: function (params) {
            params.translations = algolia.translations;
            return params;
          }
        }
      })
    );

    // Redirect to product on click
    instant.search.addWidget({
      init: function (opts) {
        $('.ais-hits-container').on('click', '.ais-hit', function (e) {
          var $this = $(this),
              handle = $this.attr('data-handle'),
              variant_id = $this.attr('data-variant-id')
              distinct = $this.attr('data-distinct');

          var link = '/products/' + handle;
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }
          if (algolia.config.analytics_enabled) {
            algolia.clickTracker(e);
          }
          window.location.href = link;
        });
        $('.ais-hits-container').on('click', '.ais-hit a', function (e) {
          e.stopPropagation();
          if (algolia.config.analytics_enabled) {
            algolia.clickTracker(e);
          }
        });
      }
    });

    // Add to cart
    instant.search.addWidget({
      init: function (opts) {

        $('.ais-hits-container').on('click', '.ais-hit', function (e) {
          e.stopPropagation();

          var $this = $(this),
              handle = $this.attr('data-handle'),
              variant_id = $this.attr('data-variant-id'),
              distinct = $this.attr('data-distinct');
              console.log($this);
          var link = '/products/' + handle;
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }
          if (algolia.config.analytics_enabled) {
            algolia.clickTracker(e);
          }
          window.location.href = link;

        });
      }
    });

    // Pages - item click event
    instant.search.addWidget({
      init: function (opts) {
        $('.ais-page-hits-container').on('click', '.ais-hit', function (event) {
          var handle = this.getAttribute("data-handle");

          if (algolia.config.analytics_enabled) {
            algolia.clickTracker(e);
          }

          window.location.href = "/pages/" + handle;
        });

        $('.ais-page-hits-container').on('click', '.ais-hit a', function (event) {
          event.stopPropagation();

          if (algolia.config.analytics_enabled) {
            algolia.clickTracker(e);
          }
        });
      }
    });

    // Pages - show Pages in results after Products
    instant.search.addWidget({
      init: function (opts) {
        $(".ais-hits-container").on("click", ".ais-infinite-hits--showmore button", function (event) {
          var productHitsContainer = $(".ais-hits-container .ais-infinite-hits");
          var pageHits = $(".ais-page-hits-container").find(".ais-infinite-hits--item").clone();
          var showButton = $(event.target);
          var facetItems = $(".ais-facet--item");

          if ( facetItems.is(".ais-facet--active") ) {
            return;
          }

          if ( productHitsContainer.find(".ais-infinite-hits--page-item").length ) {
            return;
          }

          setTimeout(function () {
            if ( showButton.prop("disabled") ) {
              productHitsContainer.append(pageHits);
            }
          }, 400);
        });
      }
    });

    // Zen desk - show Zen Desk articles in results after Products
    instant.search.addWidget({
      init: function (opts) {
        $(".ais-hits-container").on("click", ".ais-infinite-hits--showmore button", function (event) {
          var productHitsContainer = $(".ais-hits-container .ais-infinite-hits");
          var zenHits = $(".ais-zen-hits-container").find(".ais-infinite-hits--item").clone();
          var showButton = $(event.target);
          var facetItems = $(".ais-facet--item");

          if ( facetItems.is(".ais-facet--active") ) {
            return;
          }

          if ( productHitsContainer.find(".ais-infinite-hits--page-item").length ) {
            return;
          }

          setTimeout(function () {
            if ( showButton.prop("disabled") ) {
              productHitsContainer.append(zenHits);
            }
          }, 400);
        });
      }
    });

    // Pages - hide Page results when results are filtered
    instant.search.addWidget({
      init: function (opts) {
        $(".ais-facets").on("click", ".ais-facet--item", function (event) {
          var productHitsContainer = $(".ais-hits-container .ais-infinite-hits");
          var originalPageHits = $(".ais-hits-container").find(".ais-infinite-hits--page-item").clone();
          var pageHits = productHitsContainer.find(".ais-infinite-hits--page-item");

          setTimeout(function () {
            if ( $(".ais-facet--item").is(".ais-facet--active") ) {
              pageHits.remove();
            } else {
              productHitsContainer.append(originalPageHits);
            }
          }, 400);
        });
      }
    });

    // Page - hits
    instantPages.search.addWidget(
      instantsearch.widgets.hits({
        container: '.ais-page-hits-container',
        hitsPerPage: instant.hitsPerPage,
        templates: {
          empty: instantPages.templates.empty,
          item: instantPages.templates.pageItem
        },
        transformData: {
          item: function (page) {
            page.queryID = instantPages.search.helper.lastResults._rawResults[0].queryID;
            page.pagePosition = page.__hitIndex + 1;
            page.url = "/pages/" + page.handle;
            var emptyobj = {};
            return page;
          },
          empty: function (params) {
            params.translations = algolia.translations;
            return params;
          }
        },
        cssClasses: {
          item: "ais-infinite-hits--item ais-infinite-hits--page-item"
        }
      })
    );



    // Zen - hits
    instantZen.search.addWidget(
      instantsearch.widgets.hits({
        container: '.ais-zen-hits-container',
        hitsPerPage: instant.hitsPerPage,
        templates: {
          empty: instantPages.templates.empty,
          item: instantPages.templates.pageItem
        },
        transformData: {
          item: function (zen) {
            zen.queryID = instantZen.search.helper.lastResults._rawResults[0].queryID;
            zen.pagePosition = zen.__hitIndex + 1;

            // Create handle for URL
            var zenTitle = zen.title;

            //strip handle of any extra spacing or '-'
            zenTitle = zenTitle.replace(/-/g, ' ').replace(/\s+/g,'-');

            zenTitle = zenTitle.replace(/\//g, '-');

            // zen.url = "/pages/" + zen.handle;
            zen.url = "https://support.turtlebeach.com/hc/" + zen.locale.locale + "/articles/" + zen.id + "-" + zenTitle;

            var emptyobj = {};
            if(liquid.shop.permanent_domain === "os-trtl.myshopify.com" && zen.locale.locale === "en-us"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else if ( liquid.shop.permanent_domain === "os-treu.myshopify.com" && zen.locale.locale === "en-us"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else if ( liquid.shop.permanent_domain === "os-truk.myshopify.com" && zen.locale.locale === "en-us"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else if ( liquid.shop.permanent_domain === "os-trau.myshopify.com" && zen.locale.locale === "en-us"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else if ( liquid.shop.permanent_domain === "os-trnz.myshopify.com" && zen.locale.locale === "en-us"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else if ( liquid.shop.permanent_domain === "os-tres.myshopify.com" && zen.locale.locale === "es"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else if ( liquid.shop.permanent_domain === "os-trde.myshopify.com" && zen.locale.locale === "de"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else if ( liquid.shop.permanent_domain === "os-trfr.myshopify.com" && zen.locale.locale === "fr"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else if ( liquid.shop.permanent_domain === "os-trit.myshopify.com" && zen.locale.locale === "it"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else if ( liquid.shop.permanent_domain === "os-trnl.myshopify.com" && zen.locale.locale === "nl"){
              zen.className += " show-data";
              zen.attr = "_blank";
              return zen;
            } else {
              emptyobj.className += " hide-hit";
              return emptyobj;
            }
          },
          empty: function (params) {
            params.translations = algolia.translations;
            return params;
          }
        },
        cssClasses: {
          item: "ais-infinite-hits--item ais-infinite-hits--zen-item"
        }
      })
    );


    // Page - stats
    instantPages.search.addWidget(
      instantsearch.widgets.stats({
        container: '.ais-page-stats-container',
        onClick: (event, data) => {
          // event is the usual event, while data is the data passed to the template
        },
        templates: {
          body: instant.templates.stats
        },
        autoHideContainer: true,
        transformData: {
          body: function (data) {
            data.processingTimeS = data.processingTimeMS / 1000;
            data.start = data.page * data.hitsPerPage + 1;
            data.end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits);
            data.translations = algolia.translations;
            return data;
          }
        }
      })
    );

    instantZen.search.addWidget(
      instantsearch.widgets.stats({
        container: '.ais-zen-stats-container',
        templates: {
          body: instant.templates.stats
        },
        autoHideContainer: true,
        transformData: {
          body: function (data) {
            data.processingTimeS = data.processingTimeMS / 1000;
            data.start = data.page * data.hitsPerPage + 1;
            data.end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits);
            data.translations = algolia.translations;
            return data;
          }
        }
      })
    );

    // Main
    instant.search.start();
    instantPages.search.start();
    instantZen.search.start();

    $hiding.remove();

  });
}(algoliaShopify, instantsearch));

  $(function(){ $(window).bind('load', function(){
      // Phillip's instant search edits
      $(".hide-hit").parent().remove();
    });
  });
